export var products = {
    FLY: 'Flight',
    STAY: 'Hotel',
    DRIVE: 'Car',
    PACKAGE: 'Package',
};
export var productsType = {
    FLY: 'FLY',
    STAY: 'STAY',
    DRIVE: 'DRIVE',
    PACKAGE: 'PACKAGE',
};
//# sourceMappingURL=products.js.map